import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { store } from "commonui";

@Module({ namespaced: true, name: "AnnotationState", store: store, dynamic: true })
export default class AnnotationState extends VuexModule {
	isFillingColor = false;
	currentColor = "";

	@Mutation
	setIsFillingColor() {
		this.isFillingColor = !this.isFillingColor;
	}
	@Mutation
	setCurrentColor(color: string) {
		this.currentColor = color;
	}

	@Action
	async toggleFillColor() {
		this.setIsFillingColor();
	}

	@Action
	async changeColor(color: string) {
		this.setCurrentColor(color);
	}
}
